// extracted by mini-css-extract-plugin
export default {"selected":"SelectedNumber_selected__+tLfS"};